<template>
  <div class="texture-new">
    <div class="close"
      @click="$router.push('/user/surface-design-texture/' + surfaceDesignTexturesStore.selectedCollectionId)">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><path d="M5 4.25a.75.75 0 0 0-.531.219.75.75 0 0 0 0 1.062L8.937 10 4.47 14.469a.75.75 0 0 0 0 1.062.75.75 0 0 0 1.062 0L10 11.062l4.469 4.47a.75.75 0 0 0 1.062 0 .75.75 0 0 0 0-1.063L11.062 10l4.47-4.469a.75.75 0 0 0 0-1.062A.75.75 0 0 0 15 4.25a.75.75 0 0 0-.531.219L10 8.937 5.531 4.47A.75.75 0 0 0 5 4.25z"></path></svg>
      Exit
    </div>
    <div class="text-block">
      <div class="text-block__sub">
        <svg xmlns="http://www.w3.org/2000/svg" fill="#09373D" viewBox="0 0 22 22" width="24" height="24">
          <path d="M6.416 3.834a.75.75 0 0 0-.53.219L4.054 5.887a.75.75 0 0 0 0 1.06.75.75 0 0 0 1.062 0l1.832-1.834a.75.75 0 0 0 0-1.06.75.75 0 0 0-.531-.219zm5.502 0a.75.75 0 0 0-.531.219l-7.334 7.334a.75.75 0 0 0 0 1.06.75.75 0 0 0 1.062 0l7.332-7.334a.75.75 0 0 0 0-1.06.75.75 0 0 0-.529-.219zm5.615.115a.75.75 0 0 0-.531.22L4.17 17.003a.75.75 0 0 0 0 1.06.75.75 0 0 0 1.06 0L18.064 5.23a.75.75 0 0 0 0-1.06.75.75 0 0 0-.53-.22zm-.117 5.383a.75.75 0 0 0-.531.22l-7.332 7.335a.75.75 0 0 0 0 1.06.75.75 0 0 0 1.06 0l7.334-7.334a.75.75 0 0 0 0-1.06.75.75 0 0 0-.531-.221zm0 5.502a.75.75 0 0 0-.531.219l-1.832 1.834a.75.75 0 0 0 0 1.06.75.75 0 0 0 1.06 0l1.834-1.834a.75.75 0 0 0 0-1.06.75.75 0 0 0-.531-.219z" />
        </svg>
        Create texture collection
      </div>
      <h3>{{ surfaceDesignTexturesStore.selectedCollectionName }}</h3>
      <p class="text-block__subtitle">Upload images that you can then use as textures.</p>
      <p>Maximum size 10MB</p>
      <p>PNG or JPG</p>
      <p>Minimum resolution of 1024x1024</p>
      <p>Only square images are allowed</p>
    </div>
    <div class="files" :style="`grid-template-columns: repeat(${surfaceDesignTexturesStore.collumnCount}, 1fr)`">
      <div class="item" v-for="(item, index) in surfaceDesignTexturesStore.textureFiles" :key="index">
        <label :class="`import-file ${item.imgUrl ? 'file' : ''} ${item.error ? 'error' : ''} ${item.id ? 'ok' : ''}`">
          <svg v-if="!item.imgUrl && !item.url" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20" width="20" height="20">
            <path stroke="#09373D" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M5 17.5h10m-5-3.334V2.49935m4.1663 4.16667L9.99967 2.49935 5.83301 6.66602"/>
          </svg>
          <img v-else-if="item.imgUrl" :src="item.imgUrl" alt="Uploaded image"/>
          <img v-else-if="item.url" :src="`https://cdn.patternfast.com${item.url}`" alt="item image"/>
          <svg class="ok-icon" v-if="item.id && !item.url" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
            <path stroke="#09373D" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m6 12 4.2426 4.2426 8.4853-8.48528"/>
          </svg>
          <div :class="item.imgUrl || item.url ? 'edit-file' : 'edit'">
            <div class="input-container">
            <input type="file" name="img-file" accept="image/jpeg, image/png"
              @change="(e) => surfaceDesignTexturesStore.addTextureImg(e, index)">
            <svg v-if="item.imgUrl || item.url" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20" width="20" height="20">
              <path stroke="#09373D" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M3.33398 16.6669h3.33334l9.41078-9.41078c.3254-.32543.3254-.85307 0-1.17851l-2.1549-2.15482c-.3254-.32544-.853-.32544-1.1785 0L3.33398 13.3335v3.3334Z"/>
            </svg>
            </div>
          </div>
        </label>
        <div class="del" v-if="item.imgUrl || item.url" @click="surfaceDesignTexturesStore.dellTextureImg(index)">
          <svg width="20"  height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
            <path stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M15 5H5v11.6667c0 .4602.3731.8333.83333.8333h8.33337c.4602 0 .8333-.3731.8333-.8333V5ZM3.33398 5H16.6673m-4.168-2.5H7.49935c-.46024 0-.83333.3731-.83333.83333V5h6.66668V3.33333c0-.46023-.3731-.83333-.8334-.83333Z"/>
          </svg>
        </div>
        <input class="input-name" v-if="item.imgUrl || item.url"
          @input="handleName($event, index)" :value="item.name" placeholder="Add name">
        <p class="error" v-if="item.error">{{item.error}}</p>
      </div>
    </div>
    <div class="bottom-panel">
      <ButtonPrimary class="small" :disabled="!surfaceDesignTexturesStore.canSave"
        @click.native="surfaceDesignTexturesStore.saveTextures($router)">
        Save collection
      </ButtonPrimary>
    </div>
  </div>
</template>

<script>
import ButtonPrimary from '@/components/Atoms/ButtonPrimary.vue'
import { mapStores } from 'pinia'
import { useSurfaceDesignTexturesStore } from '@/store/pinia/surfaceDesignTextures'
export default {
  name: 'surfaceDesignTextureNew',
  components: {
    ButtonPrimary,
  },
  computed: {
    ...mapStores(useSurfaceDesignTexturesStore),
  },
  async mounted () {
    this.surfaceDesignTexturesStore.textureFiles = []
    this.handleResize()
    this.surfaceDesignTexturesStore.makeImgArray()
    window.addEventListener('resize', this.handleResize)
  },
  methods: {
    handleName (event, index) {
      const updatedFiles = [...this.surfaceDesignTexturesStore.textureFiles]
      updatedFiles[index] = {
        ...updatedFiles[index],
        name: event.target.value,
      }
      this.surfaceDesignTexturesStore.textureFiles = updatedFiles
    },
    handleResize () {
      const pageSize = window.innerWidth
      this.surfaceDesignTexturesStore.collumnCount =
        pageSize > 1084 ? 8 : pageSize < 768 ? Math.floor((pageSize - 23) / 116) : Math.floor((pageSize - 4) / 135)
    },
  },
}
</script>

<style lang="scss">
.texture-new {
  background: var(--Background);
  position: fixed;
  left: 0;
  top: 60px;
  width: 100%;
  height: calc(100% - 60px);
  font-size: 16px;
  font-weight: 400;
  line-height: 150%;
  color: var(--Text-Text_Secondary);
  padding: 0 22px;
  overflow: scroll;
  p {
    margin: 0;
  }
  h3 {
    color: var(--Text-Text_Primary);
    text-align: center;
    font-family: Unbounded;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 130%;
    margin: 16px 0 8px;
  }
  .close {
    position: absolute;
    top: 24px;
    left: 16px;
    display: flex;
    align-items: center;
    gap: 4px;
    color: var(--Primary-Shades-Primary);
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    cursor: pointer;
  }
  .text-block {
    margin-top: 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
    &__sub {
      display: flex;
      align-items: center;
      font-weight: 600;
      line-height: 20px;
      gap: 8px;
      color: var(--Text-Text_Primary);
    }
    &__subtitle {
      margin-bottom: 38px;
    }
  }
  .bottom-panel {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    border-top: 1px solid var(--Dividers);
    padding: 16px;
    display: flex;
    justify-content: center;
    background: var(--Background);
  }
  .files {
    display: grid;
    gap: 40px;
    max-width: 1055px;
    margin: 56px auto 128px;
    .item {
      width: 95px;
      position: relative;
      .error {
        font-size: 14px;
        color: var(--System-Error);
        line-height: 16px;
        text-align: center;
      }
      .import-file.file {
        border: 1px solid var(--Primary-Button-Surface);
      }
      .import-file.error {
        border: 1px solid var(--System-Error);
      }
      .import-file.ok {
        img { opacity: 0.8; }
        .ok-icon {
          position: absolute;
        }
      }
      .del {
        position: absolute;
        top: 28px;
        left: 28px;
        height: 40px;
        width: 40px;
        padding: 10px;
        border-radius: 8px;
        background: var(--primary);
        opacity: 0;
        cursor: pointer;
      }
      &:hover .del {
        opacity: 1;
      }
      .import-file {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 95px;
        position: relative;
        border-radius: 8px;
        border: 1px dashed var(--Dividers);
        margin-bottom: 8px;
        .edit-file {
          cursor: pointer;
          width: 24px;
          height: 24px;
          padding: 1px;
          position: absolute;
          border-radius: 4px;
          border: 1px solid var(--Secondary-Button-Stroke);
          background: var(--Basic-White);
          top: -10px;
          right: -10px;
          .input-container {
            width: 100%;
            height: 100%;
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
        .edit {
          width: 100%;
          height: 100%;
          position: absolute;
          .input-container {
            position: relative;
            width: 100%;
            height: 100%;
          }
        }
        input[type="file"] {
          position: absolute;
          width: 100%;
          height: 100%;
          font-size: 0;
          background-color: rgba(0,0,0,0);
          cursor: pointer;
          z-index: 100;
          top: 0;
          left: 0;
          &::file-selector-button {
            display: none;
          }
        }
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 8px;
        }
      }
      input:focus-visible {
        outline: none;
      }
      input::placeholder {
        color: var(--Primary-Button-Surface);
      }
      .input-name {
        width: 100%;
        border: none;
        color: var(--Primary-Button-Surface);
        font-size: 14px;
        text-align: center;
        &::placeholder {
          color: var(--Active-State-Strokes);
        }
      }
    }
  }
}
@media (max-width: 768px) {
  .texture-new {
    font-size: 14px;
    h3 { font-size: 18px; }
    .text-block {
      margin-top: 78px;
      &__sub { font-size: 16px; }
      &__subtitle { margin-bottom: 16px; }
    }
    .files {
      margin: 40px auto 112px;
      gap: 21px;
    }
  }
}
</style>
